export default __webpack_public_path__ + "2965e29d266ec30a32443b334e8b63f2.svg";